import { GetLocationAuditsParams } from "./location-audit.services";

export const LOCATION_AUDIT_KEYS = {
  all: ["location-audits"] as const,
  GET_AUDITS: (params?: GetLocationAuditsParams) =>
    [...LOCATION_AUDIT_KEYS.all, "list", params] as const,
  GET_AUDIT: (id: string) => [...LOCATION_AUDIT_KEYS.all, "detail", id] as const,
  GET_INVENTORIES_BY_LOCATION: (locationId: string, page?: number, limit?: number) =>
    [...LOCATION_AUDIT_KEYS.all, "inventories", locationId, page, limit] as const,
};
